import { z } from 'zod';

export const statusSchema = z.object({
  id: z.string(),
  type: z.string(),
  description: z.string(),
});

export const isStatus = (obj: any): obj is z.infer<typeof statusSchema> => {
  return statusSchema.safeParse(obj).success;
};
